import React, {Component} from 'react';
import {Button, Menu} from 'semantic-ui-react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import {isLoggedIn} from '../../reducer';
import {Translate} from "react-localize-redux";


class LoginButton extends Component {


    render() {
        if (!this.props.loggedIn) {
            return (
                <Menu.Item position='right'>
                    <Button as={Link} to={'/login'} inverted={!this.props.fixed}  style={{marginLeft: '0.5em'}}><Translate id="login" /></Button>
                </Menu.Item>
            );
        }

        return null;
    }
}

const mapStateToProps = state => ({
    loggedIn: isLoggedIn(state)
})



export default connect(
    mapStateToProps,
    null,
    null
)(LoginButton)


// WEBPACK FOOTER //
// ./src/components/LoginButton/index.js